<div>
    <div class="tabHeading">
        <h3>Total Population at Risk</h3>
    </div>

    <div class="flex flex-col simChart">
        <!-- Display-only: chosen min to selected (max) -->
        <p>{{ displayRange }}</p>
        <p>Total population at risk - {{ formatMillions(stats.totalPopulationAtRisk) }}</p>

        <div class="rounded-xl bg-white p-4 flex items-center justify-center overflow-hidden">
            @if (chartData) {
            <p-chart type="doughnut" [data]="chartData" [options]="chartOptionsSmallTooltipCenterTitle" width="160" height="170"></p-chart>
            }
        </div>

        <!-- Stat cards -->
        <div class="flex-1">
            <div class="flex flex-wrap gap-4 p-4">
                <!-- Normal BP -->
                <div class="rounded-xl border border-slate-200 bg-white p-2 basis-full sm:basis-[calc(50%-0.5rem)] flex-grow">
                    <div class="f12 font-semibold">{{ formatNumber(stats.normalBP) }}</div>
                    <div class="mt-2 flex items-center gap-2">
                        <span class="inline-block h-3 w-3 rounded-sm" [style.background]="seriesColors[0]"></span>
                        <span class="f12">Normal BP</span>
                        <p-popover #normalBpPopover [style]="{ width: '22rem' }">
                            <ng-template pTemplate="header">
                                <div class="text-sm font-semibold">Normal BP</div>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <div class="text-xs text-slate-700">Normal BP is usually considered to be between 90/60 mmHg and 120/80 mmHg (i.e. &lt;120/80 mmHg).</div>
                                <div class="mt-2">
                                    <button pButton type="button" class="p-button-text p-button-sm" (click)="normalBpPopover.hide()">Close</button>
                                </div>
                            </ng-template>
                        </p-popover>
                    </div>
                </div>

                <!-- Pre-hypertension -->
                <div class="rounded-xl border border-slate-200 bg-white p-2 basis-full sm:basis-[calc(50%-0.5rem)] flex-grow">
                    <div class="f12 font-semibold">{{ formatNumber(stats.preHypertension) }}</div>
                    <div class="mt-2 flex items-center gap-2">
                        <span class="inline-block h-3 w-3 rounded-sm" [style.background]="seriesColors[2]"></span>
                        <span class="f12">Pre-hypertension</span>
                        <p-popover #preHypPopover [style]="{ width: '22rem' }">
                            <ng-template pTemplate="header">
                                <div class="text-sm font-semibold">Pre-hypertension</div>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <div class="text-xs text-slate-700">Pre-hypertension is when you do not have an ideal BP but you also do not have high BP. Usually considered to be between 120/80 and 140/90 mmHg.</div>
                                <div class="mt-2">
                                    <button pButton type="button" class="p-button-text p-button-sm" (click)="preHypPopover.hide()">Close</button>
                                </div>
                            </ng-template>
                        </p-popover>
                    </div>
                </div>

                <!-- Hypertension -->
                <div class="rounded-xl border border-slate-200 bg-white p-2 basis-full sm:basis-[calc(50%-0.5rem)] flex-grow">
                    <div class="f12 font-semibold">{{ formatNumber(stats.hypertensionTotal) }}</div>
                    <div class="mt-2 flex items-center gap-2">
                        <span class="inline-block h-3 w-3 rounded-sm" [style.background]="seriesColors[1]"></span>
                        <span class="f12">Hypertension</span>
                        <p-popover #htPopover [style]="{ width: '22rem' }">
                            <ng-template pTemplate="header">
                                <div class="text-sm font-semibold">Hypertension</div>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <div class="text-xs text-slate-700">Consistently 130/80 mmHg or above. Increases risk of heart disease and stroke.</div>
                                <div class="mt-2">
                                    <button pButton type="button" class="p-button-text p-button-sm" (click)="htPopover.hide()">Close</button>
                                </div>
                            </ng-template>
                        </p-popover>
                    </div>
                </div>

                <!-- CVD Patients -->
                <div class="rounded-xl border border-slate-200 bg-white p-2 basis-full sm:basis-[calc(50%-0.5rem)] flex-grow">
                    <div class="f12 font-semibold">{{ formatNumber(stats.cvdPatients) }}</div>
                    <div class="mt-2 flex items-center gap-2">
                        <span class="inline-block h-3 w-3 rounded-sm" [style.background]="seriesColors[3]"></span>
                        <span class="f12">CVD</span>
                        <p-popover #cvdPopover [style]="{ width: '22rem' }">
                            <ng-template pTemplate="header">
                                <div class="text-sm font-semibold">CVD</div>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <div class="text-xs text-slate-700">A group of heart and blood vessel conditions, including heart attacks and strokes. Often linked to high BP, smoking and diabetes.</div>
                                <div class="mt-2">
                                    <button pButton type="button" class="p-button-text p-button-sm" (click)="cvdPopover.hide()">Close</button>
                                </div>
                            </ng-template>
                        </p-popover>
                    </div>
                </div>
            </div>
        </div>

        <!-- Year slider: left thumb = minYear (display only), right thumb = selectedYear (drives logic) -->
        <div class="px-4 pb-4">
            <div class="flex items-center justify-between mb-2">
                <span class="text-xs text-slate-600">Year: {{ selectedYear }}</span>
                <!-- Display the chosen min/max instead of dataset bounds -->
                <span class="text-xs text-slate-500">Range: {{ displayRange }}</span>
            </div>

            <p-slider [(ngModel)]="rangeValues" [range]="true" [min]="sliderYearMin" [max]="sliderYearMax" [step]="1" (onSlide)="onYearSlide($event)" (onChange)="onYearChange()" class="w-full"> </p-slider>
        </div>
    </div>
</div>
